export default "__VITE_ASSET__DTKFmNzw__"